import React from 'react';
import Button from 'react-bootstrap/Button';
import { CgCloseR } from "react-icons/cg";


const DefaultAssignmentDetail = ({ rights, t, isDisabled, hotelcleanersarray, cleaningtaskADarray, data, events }) => {
    return (
        <>
            <div id="Defaultassignmentdetails" className='assignmentdiv'>
                {/* <div className='formcaption' onMouseDown={(e) => events.startdrag("Defaultassignmentdetails", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>
                    {t('DefaultTaskTitle')} 
                    <CgCloseR className='closer' onClick={events.handleCancel} />
                    </div> */}

                <div className='formcaption'>
                    <div onMouseDown={(e) => events.startdrag("Defaultassignmentdetails", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>
                        {t('DefaultTaskTitle')}
                    </div>
                    <div onClick={events.handleCancel} >
                        <CgCloseR className='closer' />
                    </div>
                </div>
                <div className="AssignCleaningform">
                    <label className='labelhotel'>
                        {t('Title')}
                    </label>
                    <input id="title" name="title" className="doublegrid" value={data.cleaningassignment.title} type='text' onChange={events.handleOnchange} disabled={isDisabled}>
                    </input>
                    <label className='labelhotel'>
                        {t('extrataken')}
                    </label>
                    <div id="extratasks" name="extratasks" type='text' disabled={isDisabled} className='checkboxDiv doublegrid'>
                        {cleaningtaskADarray}
                    </div>
                    <label className='labelhotel'>
                        {t('Opmerking')}
                    </label>
                    <textarea id="taken" name="description" value={data.cleaningassignment.description} className="doublegrid opmerkingen" type='text' onChange={events.handleOnchange} disabled={isDisabled}>
                    </textarea>
                    <label className='labelhotel'>
                        {t('Duration')}:
                    </label>
                    <select id="extratime" name="extratime" className="doublegrid" type='text' value={data.cleaningassignment.extratime} onChange={events.handleOnchange} disabled={isDisabled}>
                        <option value="-1">{t('Select duration')}</option>
                        <option value="0">{t('No Extra Time needed')}</option>
                        <option value="5">5 min</option>
                        <option value="10">10 min</option>
                        <option value="15">15 min</option>
                        <option value="30">30 min</option>
                        <option value="45">45 min</option>
                        <option value="60">1u</option>
                        <option value="75">1u15 min</option>
                        <option value="90">1u30 min</option>
                        <option value="105">1u45 min</option>
                        <option value="120">2u</option>
                        <option value="135">2u15 min</option>
                        <option value="150">2u30 min</option>
                        <option value="165">2u45 min</option>
                        <option value="180">3u</option>
                        <option value="195">3u15 min</option>
                        <option value="210">3u30 min</option>
                        <option value="225">3u45 min</option>
                        <option value="240">4u</option>
                        <option value="255">4u15 min</option>
                        <option value="270">4u30 min</option>
                        <option value="285">4u45 min</option>
                        <option value="300">5u</option>


                        <option value="315">5u15 min</option>
                        <option value="330">5u30 min</option>
                        <option value="345">5u45 min</option>
                        <option value="360">6u</option>
                        <option value="375">6u15 min</option>
                        <option value="390">6u30 min</option>
                        <option value="405">6u45 min</option>
                        <option value="420">7u</option>
                        <option value="435">7u15 min</option>
                        <option value="450">7u30 min</option>
                        <option value="465">7u45 min</option>
                        <option value="480">8u</option>
                        <option value="495">8u15 min</option>
                        <option value="510">8u30 min</option>
                        <option value="525">8u45 min</option>
                        <option value="540">9u</option>
                        <option value="555">9u15 min</option>
                        <option value="570">9u30 min</option>
                        <option value="585">9u45 min</option>
                        <option value="600">10u</option>
                        <option value="615">10u15 min</option>
                        <option value="630">10u30 min</option>
                        <option value="645">10u45 min</option>
                        <option value="660">11u</option>
                        <option value="675">11u15 min</option>
                        <option value="690">11u30 min</option>
                        <option value="705">11u45 min</option>
                        <option value="720">12u</option>
                    </select>
                    <label className='labelhotel'>
                        {t('Medewerker')}:
                    </label>
                    <select id="assignee_Id" name="assignee_Id" className="doublegrid" type='text' value={data.cleaningassignment.assignee_Id} onChange={events.handleOnchange} disabled={isDisabled}>
                        <option value={-1}>{t('SelectEmployee')}</option>
                        {hotelcleanersarray}
                    </select>
                    <Button type="button" id="DefaultdeleteButton" onClick={() => events.handlDeleteAssignment(data.cleaningassignment)} className="Deletebutton" disabled={isDisabled} style={{ display: "none" }}>{t('Delete')}</Button>
                    <div id="saveDiv" className="two_Buttons doublegrid">
                        <Button type="button" id="DefaultEditButton" onClick={() => events.handlEditDefaultAssignment()} className="Savebutton" disabled={!isDisabled} style={isDisabled === false ? { display: "none" } : { display: "block" }}>{t('Edit')}</Button>
                        <Button type="button" id="DefaultupdateButton" onClick={() => events.handlUpdateDefaultAssignment(data.cleaningassignment.id)} className="Savebutton" style={{ display: "none" }}>{t('update')}</Button>
                        <Button type="button" id="DefaultsaveButton" onClick={() => events.handlCreateDefaultAssignment()} className="Savebutton" disabled={isDisabled} >{t('Save')}</Button>
                        <Button type="button" id="cancelButton" className="Savebutton" onClick={events.handleCancel}>{t('Cancel')}</Button>
                    </div>

                </div>
            </div>
        </>
    );
}


export default DefaultAssignmentDetail;
